import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION32: PdfComponent = {
  type: 'section',
  id: 's32',
  title: '32. Waiver',
  content: [
    {
      type: 'bulletList',
      id: 's32bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'No failure, delay or omission by any party in exercising any right, power or remedy provided by law or under this Agreement shall operate as a waiver of that right, power or remedy, nor shall it preclude or restrict any further exercise of that or any other right, power or remedy.',
        },
        {
          copy: 'No single or partial exercise of any right, power or remedy provided by law or under this Agreement shall prevent any further exercise of it or the exercise of any other right, power or remedy.',
        },
        {
          copy: 'A waiver of any term, provision, condition or breach of this Agreement shall only be effective if given in writing and signed by the waiving party. Any such waiver shall apply only in the instance and for the purpose for which it is given and shall not constitute a waiver of any other right.',
        },
      ],
      prefix: '32',
    },
  ],
};
